<template>
  <a-table class="stripped table-hover" :columns="columns" :data-source="data" :pagination="false"
    :row-selection="rowSelection">
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'Name'">
        <h2 class="table-avatar d-flex align-items-center">
          <router-link :to="{ path: '/supplier/create-supplier', query: { userId: record.key } }"
            class="profile-split d-flex flex-column">{{ record.name }}</router-link>
        </h2>
      </template>
      <template v-else-if="column.key === 'action'">
        <router-link :to="{ path: '/supplier/create-supplier', query: { userId: record.key } }"
          class="btn table_action_btn"><i class="ti ti-edit"></i> Edit</router-link>
        <a class="btn table_action_btn ms-2" href="javascript:;" @click="confirmDelete(record.key)">
          <i class="ti ti-trash text-danger"></i> Delete
        </a>
      </template>
    </template>
  </a-table>

      <!-- Fixed Pagination -->
      <div class="pagination-container" v-if="data.length > 0">
    <a-pagination :current="pagination.current" :pageSize="pagination.pageSize" :total="pagination.total"
      showSizeChanger :pageSizeOptions="pageSizeOptions" @change="handleTableChange" class="d-flex" />
  </div>

  <div class="modal-backdrop fade show" v-if="showDeleteModal"></div>
  <div v-if="showDeleteModal" class="modal custom-modal fade show" style="display: block;" tabindex="-1"
    win_probability="dialog" aria-modal="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0 m-0 justify-content-end">
          <button class="btn-close" @click="showDeleteModal = false" aria-label="Close">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="success-message text-center">
            <div class="success-popup-icon">
              <i class="ti ti-trash-x"></i>
            </div>
            <h3>Delete Supplier</h3>
            <p class="del-info">Are you sure you want to delete?</p>
            <div class="col-lg-12 text-center modal-btn">
              <button class="btn btn-light" @click="showDeleteModal = false">Cancel</button>
              <button class="btn btn-danger" @click="deleteSupplier(selectedUserId)">Yes, Delete it</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  reactive,
  onMounted,
  computed
} from 'vue';
import {
  useRouter
} from 'vue-router';
import apiClient from "@/axios";
import {
  message
} from "ant-design-vue";

export default {
  props: {
    searchUserQuery: String,
    // filters: Object,
  },
  setup(props) {
    const router = useRouter();

    // Reactive state
    const columns = [{
      title: "Name",
      dataIndex: "name",
      key: "Name",
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name)
      }
    },
    // {
    //   title: "Gas",
    //   dataIndex: "gas",
    //   sorter: {
    //     compare: (a, b) => {
    //       return a.gas - b.gas; 
    //     },
    //   }
    // },
    // {
    //   title: "Electricity",
    //   dataIndex: "electricity",
    //   sorter: {
    //     compare: (a, b) => {
    //       return a.electricity - b.electricity;
    //     },
    //   }
    // },
    {
      title: "Action",
      dataIndex: "Action",
      key: "action",
      sorter: false
    },
    ];

    const data = ref([]);
    const pagination = ref({
      current: 1,
      pageSize: 10,
      total: 0
    });
    const rowSelection = reactive({
      onChange: () => { },
      onSelect: () => { },
      onSelectAll: () => { },
    });
    const showDeleteModal = ref(false);
    const selectedUserId = ref(null);

    const pageSizeOptions = computed(() => {
      let options = [10]; // Default option
      if (pagination.value.total > 10) options.push(20);
      if (pagination.value.total > 20) options.push(50);
      if (pagination.value.total > 50) options.push(100);
      return options;
    });

    const fetchSupplier = async (page = 1, pageSize = 10) => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          return;
        }
        const response = await apiClient.get("/suppliers", {
          params: {
            search: props.searchUserQuery,
            page,
            pageSize
          }
        });
        if (response.status) {
          data.value = response.data.data.data.map((supplier) => ({
            key: supplier.id,
            name: supplier.name,
            // gas: supplier.gas,
            // electricity: supplier.electricity,
          }));
          pagination.value.total = response.data.data.total;
        } else {
          console.error("Failed to fetch suppliers:", response);
        }
      } catch (error) {
        console.error("Error fetching suppliers:", error);
      }
    };

    const deleteSupplier = async (id) => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          message.error("No token found. Please log in again.");
          return;
        }
        const response = await apiClient.delete(`/suppliers/delete/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          },
        });
        if (response.status) {
          message.success("Supplier deleted successfully!");
          showDeleteModal.value = false;
          fetchSupplier(pagination.value.current, pagination.value.pageSize);
        } else {
          showDeleteModal.value = false;
          message.error(response.message);
        }
      } catch (error) {
        showDeleteModal.value = false;
        message.error(error.response.data.message);
        
      }
    };
    const confirmDelete = (id) => {
      selectedUserId.value = id;
      showDeleteModal.value = true;
    };

    const handleTableChange = (current, pageSize) => {
      pagination.value.current = current;
      pagination.value.pageSize = pageSize;
      fetchSupplier(pagination.value.current, pagination.value.pageSize);
    };

    // Lifecycle hook
    onMounted(async () => {
      await fetchSupplier();
    });

    return {
      columns,
      data,
      pagination,
      rowSelection,
      showDeleteModal,
      selectedUserId,
      fetchSupplier,
      deleteSupplier,
      confirmDelete,
      handleTableChange,
      pageSizeOptions,
      dataCount: data,
    };
  },
};
</script>